import {useTranslation} from 'react-i18next'

import {IconCopy, IconLocation} from '@sdox/icons'
import {ContactInfoRow, CopyButton} from '@sdox/ui'

import {GoogleMapsButton} from '../../Dialogs/ContactCard/GoogleMapsButton'
import {getGoogleMapsLinkByCoordinates} from './utils'

import type {DealerStampProps} from '../DealerStamp'

interface DealerAddressRowProps {
  address: DealerStampProps['address']
  coordinates: {
    long: string
    lat: string
  } | null
}

export const DealerAddressRow = (props: DealerAddressRowProps) => {
  const {address, coordinates} = props
  const {street, zipCode, city, streetNumber} = address
  const cityWithZipcode = [zipCode, city].filter(Boolean).join(' ')
  const streetWithNumber = [street, streetNumber].filter(Boolean).join(' ')
  const addressText = [streetWithNumber, cityWithZipcode].filter(Boolean).join(', ')
  const googleMapsUrl = coordinates ? getGoogleMapsLinkByCoordinates(coordinates) : null
  const {t} = useTranslation()

  if (!addressText) return null

  return (
    <ContactInfoRow
      leading={<IconLocation/>}
      trailing={(
        <>
          <CopyButton
            copyContent={addressText}
            size={'small'}
            aria-label={t('common:copy')}
            title={t('common:copy')}
            variant={'flat'}
            mboAttrs={{prefix: 'ContactPersonDialog', piece: 'AddressCopy'}}
          />
          {googleMapsUrl ? (
            <GoogleMapsButton
              href={googleMapsUrl}
              size={'small'}
              variant={'flat'}
              mboAttrs={{prefix: 'ContactPersonDialog', piece: 'AddressOpen'}}
            />
          ) : null}
        </>
      )}
    >
      {addressText}
    </ContactInfoRow>
  )
}
